export const apiStateType = {
  idle: 'idle',
  sent: 'sent',
  error: 'error',
  ok: 'ok'
}

export const diningPreferenceType = {
  forHere: 'forHere',
  takeAway: 'takeAway',
  preOrder: 'preOrder'
}

export const receiptCarrierType = {
  paper: 'paper',
  easyCard: 'easyCard',
  barcode: 'barcode',
  cdc: 'cdc',
  donate: 'donate'
}

export const paymentMethodType = {
  cash: 'cash',
  easyCard: 'easyCard',
  creditCard: 'creditCard',
  linePayOnline: 'linePayOnline',
  linePayPhysical: 'linePayPhysical',
  chinaUnionPay: 'chinaUnionPay',
  jkos: 'jkos',
  others: 'others'
}

export const orderStatusType = {
  pending: 'pending',
  preparing: 'preparing',
  done: 'done',
  delivered: 'delivered'
}

export const userSignInStatusType = {
  processing: 'processing',
  signedIn: 'signedIn',
  signedOut: 'signedOut'
}

export const questionType = {
  radioQuestion: 'radio',
  checkboxQuestion: 'checkbox',
  switchQuestion: 'switch',
  numberQuestion: 'number',
  numberGroupQuestion: 'numberGroup'
}

export const permissionType = {
  storeUserBasic: 'STORE_USER_BASIC',
  cashierBasic: 'CASHIER_BASIC',
  monitorBasic: 'MONITOR_BASIC',
  createStore: 'CREATE_STORE',
  getStatistics: 'GET_STATISTICS',
  getStoreInfo: 'GET_STORE_INFO',
  updateStoreInfo: 'UPDATE_STORE_INFO',
  deleteStore: 'DELETE_STORE',
  getOrder: 'GET_ORDER',
  createOrder: 'CREATE_ORDER',
  updateOrderContent: 'UPDATE_ORDER_CONTENT',
  updateOrderProcessStatus: 'UPDATE_ORDER_PROCESS_STATUS',
  updateOrderPaymentStatus: 'UPDATE_ORDER_PAYMENT_STATUS',
  updateOrderReceiptPrintedStatus: 'UPDATE_ORDER_RECEIPT_PRINTED_STATUS',
  refundOrder: 'REFUND_ORDER',
  deleteOrder: 'DELETE_ORDER',
  getStoreMenuDraft: 'GET_STORE_MENU_DRAFT',
  createStoreMenuDraft: 'CREATE_STORE_MENU_DRAFT',
  updateStoreMenuDraft: 'UPDATE_STORE_MENU_DRAFT',
  deleteStoreMenuDraft: 'DELETE_STORE_MENU_DRAFT',
  releaseStoreMenu: 'RELEASE_STORE_MENU',
  getUserPermission: 'GET_USER_PERMISSION',
  updateUserPermission: 'UPDATE_USER_PERMISSION',
  updateAdminPermission: 'UPDATE_ADMIN_PERMISSION'
}
